module.exports = __webpack_public_path__ + "assets/images/officeBuilding-04.77140410c7a833b40c06f427177b9392.svg";